// extracted by mini-css-extract-plugin
module.exports = {"sd-picker":"sd-picker___3U1mD"};